/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Cap_Library_Example_UpdateInputs */

const en_mcp_cap_library_example_update = /** @type {(inputs: Mcp_Cap_Library_Example_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekly team update`)
};

const es_mcp_cap_library_example_update = /** @type {(inputs: Mcp_Cap_Library_Example_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novedades semanales del equipo`)
};

/**
* | output |
* | --- |
* | "Weekly team update" |
*
* @param {Mcp_Cap_Library_Example_UpdateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_cap_library_example_update = /** @type {((inputs?: Mcp_Cap_Library_Example_UpdateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Cap_Library_Example_UpdateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_cap_library_example_update(inputs)
	return en_mcp_cap_library_example_update(inputs)
});